import React from "react";
import { IBusinessProcessTemplate } from "pages/References/BusinessProcessRegistry/model";
import sass from "pages/References/BusinessProcessRegistry/register.module.sass";
import { ReactComponent as ActionMenuIcon } from "images/ActionMenuIcon.svg";
import { useNavigate } from "react-router-dom";
import EmptyTable from "pages/References/BusinessProcessRegistry/Components/EmptyTable";

interface ITableProps {
	render: IBusinessProcessTemplate[];
	confirmTemplate: () => void;
	toggleTarget: (e: React.MouseEvent<HTMLOrSVGElement>) => void;
	setCurrent: (any: string) => void;
	rowClick: (_: IBusinessProcessTemplate) => void;
	select: boolean;
}

const Table: React.FC<ITableProps> = ({ rowClick, toggleTarget, render, select }) => {
	const navigate = useNavigate();
	const toOrgPage = (e: React.MouseEvent, item: IBusinessProcessTemplate) => {
		if (item.organization && item.organization.id) {
			e.stopPropagation();
			navigate(`/organization/${item.organization.id}`);
		}
	};
	return render.length ? (
		<table>
			<tbody>
				{render.map((_, index) => {
					return (
						<tr key={index} onClick={() => rowClick(_)}>
							<td>{index + 1}</td>
							<td>{_.name}</td>
							<td className={_.organization ? sass.link : ""}>
								<span onClick={(e) => toOrgPage(e, _)}>
									{_.organization ? _.organization.shortName : <span dangerouslySetInnerHTML={{ __html: "&#8212;" }} />}
								</span>
							</td>
							<td>{_.comment ? _.comment : <span dangerouslySetInnerHTML={{ __html: "&#8212;" }} />}</td>
							<td>{!select && <ActionMenuIcon data-id={_.patternId} onClick={toggleTarget} />}</td>
						</tr>
					);
				})}
			</tbody>
		</table>
	) : (
		<EmptyTable>
			<p>Тут пока пусто</p>
			<p>Добавьте шаблон</p>
		</EmptyTable>
	);
};

export default Table;
